import { combineReducers } from "redux";
import indexReducerKegiatan from "./indexReducerKegiatan";
import indexReducerBlog from "./indexReducerBlog";

export default combineReducers({
    indexReducerKegiatan,
    indexReducerBlog,
});
